import React, { useState } from 'react'
import { Text } from '../../../../Components/Screen/Text/Body'
import { ButtonOutline } from '../../../../Components/Screen/Button/button'
import { MapTrifold, FileText } from '@phosphor-icons/react'
import FarmMap from './MapContainer'
import { ModalGeoJSONUpload } from '../modals/GeoJSONUpload'
import { ModalDemonstrativo } from '../modals/Demonstrativo'
import { DemonstrativosList } from './DemonstrativosList'
import { auth } from '../../../../firebase'

const UPLOAD_ALLOWED_EMAILS = ['bmadeira@farmie.io', 'douglas04041996@hotmail.com']

export const ArtInfos = (props) => {
  const { art } = props
  const [showGeoModal, setShowGeoModal] = useState(false)
  const [showDemoModal, setShowDemoModal] = useState(false)
  const [demoRefreshKey, setDemoRefreshKey] = useState(0)
  const canUpload = UPLOAD_ALLOWED_EMAILS.includes(auth?.currentUser?.email)

  return (
    <div className="flex flex-col gap-8 pt-8 px-4 lg:px-0 w-full max-w-3xl">
      <img
        src={art?.withoutqr}
        alt="art"
        className="w-full max-h-[500px] object-contain object-center rounded-lg"
      />
      <div className="flex flex-col gap-8 items-center w-full">
        <FarmMap nftId={art?.car} />

        {art?.car && canUpload && (
          <div className="flex flex-wrap gap-3 justify-center">
            <ButtonOutline onClick={() => setShowGeoModal(true)}>
              <span className="inline-flex items-center gap-2">
                <MapTrifold size={18} />
                Dados geoespaciais
              </span>
            </ButtonOutline>
            <ButtonOutline onClick={() => setShowDemoModal(true)}>
              <span className="inline-flex items-center gap-2">
                <FileText size={18} />
                Demonstrativo
              </span>
            </ButtonOutline>
          </div>
        )}

        {showGeoModal && (
          <ModalGeoJSONUpload nftId={art?.car} onClose={() => setShowGeoModal(false)} />
        )}
        {showDemoModal && (
          <ModalDemonstrativo
            nftId={art?.car}
            onClose={() => {
              setShowDemoModal(false)
              setDemoRefreshKey((k) => k + 1)
            }}
          />
        )}

        {art?.car && <DemonstrativosList nftId={art?.car} refreshKey={demoRefreshKey} />}

        <div className="flex flex-col gap-2 w-full max-w-md">
          <Text className="text-laranja">
            Nome: <Text>{art?.name}</Text>
          </Text>
          <Text className="text-laranja">
            Registro: <Text>{art?.matricula || 'Não informado'}</Text>
          </Text>
          <Text className="text-laranja">
            CAR: <Text>{art?.car || 'Não informado'}</Text>
          </Text>
          <Text className="text-laranja">
            PRA: <Text>{art?.pra || 'Não informado'}</Text>
          </Text>
        </div>
      </div>
    </div>
  )
}
